  // User Preferences API client: read/store label format per user & carrier (in PackagePrintSticker modal)
import getApiRoute from 'routes/apiRoutes';
import SecureFetchContext from 'context/SecureFetchContext'; // authenticated fetch helper
import React from 'react';

export const useUserPreferencesApi = () => {
  // obtain secure fetch (adds auth headers, error handling)
  const secureFetch = React.useContext(SecureFetchContext);

  // read preferred label format for given carrier
  const getLabelFormat = async (carrier) => {
    const base = getApiRoute('usersettings');
    const url = `${base}label-format?carrier=${encodeURIComponent(carrier)}`;
    const json = await secureFetch(url, null, 'GET');
    if (json && typeof json.format === 'string') return json.format;
    return null;
  };

  // store preferred label format for given carrier
  const setLabelFormat = async (carrier, format) => {
    const base = getApiRoute('usersettings');
    const url = `${base}label-format`;
    await secureFetch(url, { carrier, format }, 'PUT');
  };

  // expose API methods to consumers
  return { getLabelFormat, setLabelFormat };
};
